/** 系统设置路由 */
export default{
    name: 'company',
    path: 'company',
    meta: { title: '公司管理' },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'company-member',
            path: 'member',
            meta: { title: '成员管理' },
            component: ()=>import('@/pages/company/member.vue')
        },
        {
            name: 'company-department',
            path: 'department',
            meta: { title: '部门管理' },
            component: ()=>import('@/pages/company/department.vue')
        },
        {
            name: 'company-team',
            path: 'team',
            meta: { title: '小组管理' },
            component: ()=>import('@/pages/company/team.vue')
        },
        {
            name: 'company-power',
            path: 'power',
            meta: { title: '权限管理' },
            component: ()=>import('@/pages/company/power.vue')
        }
    ]
}
